import api from "./client";

export function getApprovedAttorneys() {
  return api.get("/inmate/approved-attorneys");
}

export function uploadInmateDocument(formData) {
  return api.post("/inmate/documents/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
